export default __webpack_public_path__ + "static/media/after@3x.ea9c21a2.png";